import { Component, OnInit } from '@angular/core';
import { ApisService } from 'src/app/service/APIs/apis.service';

@Component({
  selector: 'app-customer-review',
  templateUrl: './customer-review.component.html',
  styleUrls: ['./customer-review.component.scss']
})
export class CustomerReviewComponent implements OnInit {

  public testimonies: any;
  public logo: any = "../../../../assets/img/icon2.png";
  public avatar: any = "../../../../assets/img/avatar.png";

  constructor(
    private apiService: ApisService
  ) { }

/**get all testimonies */
  getAllTestimony() {
    // console.log('hey');
    
    this.apiService.getAllTestimony().subscribe({
      next: (data: any) => {
        // console.log('response', data);
        this.testimonies = data;
      },
      error: (err) => console.log('error', err),
    });
  }


  ngOnInit(): void {
    this.getAllTestimony();
  }

  reviews = [
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    },
    {
      logo: "../../../../assets/img/icon2.png",
      image: "../../../../assets/img/user.png",
      caption: "Best terminal service in Africa",
      userName: "John Doe",
      userTitle: "CEO, Dafexy Digital",
      review: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo"
    }
  ]

}
